




















import { defineComponent, PropType } from '@vue/composition-api';
import { DiscourseUnit, LocaleCode } from '@oare/types';
import { DiscourseHtmlRenderer, convertSideNumberToSide } from '@oare/oare';
import { formatLineNumber } from '@oare/oare/src/tabletUtils';
import i18n from '@/i18n';

export default defineComponent({
  props: {
    discourseUnits: {
      type: Array as PropType<DiscourseUnit[]>,
      required: true,
    },
    discourseUuids: {
      type: Array as PropType<String[]>,
      required: true,
    },
  },
  setup({ discourseUnits }) {
    const discourseRenderer = new DiscourseHtmlRenderer(
      discourseUnits,
      i18n.locale as LocaleCode
    );

    return {
      discourseRenderer,
      formatLineNumber,
      convertSideNumberToSide,
    };
  },
});
